import axios from 'axios'

const NotificationService = {
  async getList (params = {}) {
    return axios.get('shared/notifications', { params })
  },

  async markAsRead (ids = []) {
    return axios.post('shared/notifications/mark-as-read', { ids })
  }
}

export default NotificationService
